import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import IdentityContext from '../../contexts/IdentityContext';
import { useRoutes } from '../../hooks/useRoutes';

export default function RequireAuth() {
  const { buildAbsolutePath } = useRoutes();
  const { pathname, search } = useLocation();

  const urlSearchParams = new URLSearchParams({ returnUrl: [pathname, search].join('') });

  const {
    identity: { isAuthenticated },
  } = useContext(IdentityContext);

  if (!isAuthenticated) {
    return <Navigate to={`${buildAbsolutePath(['LOGIN'])}?${urlSearchParams.toString()}`} replace />;
  }

  return <Outlet />;
}
